import React, { useState } from 'react';
import axios from 'axios';
import * as Routes from 'modules/routes';
import Modal, { useModalManager, Footer } from '../../../common/Modal';

export type GameType = 'challenge' | 'reading_game' | 'state_capitals' | 'vocabulary_game';

interface BaseGameResetButtonProps {
  classroomId?: number | string;
  exerciseResultId: string;
  gameId: string;
  gameType: GameType;
  programId?: number | string;
  submissionId?: number;
}

interface ChallengeResetButtonProps extends BaseGameResetButtonProps {
  classroomId: number;
  gameType: 'challenge';
  programId: number;
  submissionId: number;
}

type GameResetButtonProps = Prettify<BaseGameResetButtonProps | ChallengeResetButtonProps>;

const GameResetButton = ({
  classroomId,
  exerciseResultId,
  gameId,
  gameType,
  programId,
  submissionId,
}: GameResetButtonProps) => {
  const modalManager = useModalManager();
  const [loading, setLoading] = useState(false);

  const gameTypesHash: Partial<Record<GameType, string>> = {
    challenge: 'Lesson Review',
    state_capitals: 'State Capitals',
    vocabulary_game: 'Vocabulary',
  };

  const resetScores = () => {
    setLoading(true);
    if (gameType === 'reading_game') {
      axios
        .post(Routes.plato_api_reset_reading_games_exercise_result_path(exerciseResultId))
        .then(() => {
          window.location.reload();
        })
        .catch((e) => {
          console.log(e);
          setLoading(false);
        });
    } else if (gameType === 'challenge') {
      axios
        .delete(
          Routes.teacher_challenge_score_path(
            exerciseResultId, {
              classroom_id: classroomId,
              format: 'json',
              program_id: programId,
              submission_id: submissionId,
            },
          ),
        )
        .then(() => {
          window.location.reload();
        });
    } else {
      axios
        .delete(Routes.plato_api_game_exercise_result_path(gameId, exerciseResultId))
        .then(() => { window.location.reload(); })
        .catch((e) => {
          console.log(e);
          setLoading(false);
        });
    }
  };

  const footer = () => (
    <Footer
      primaryButtonCallback={resetScores}
      primaryButtonDisabled={loading}
      primaryButtonSubmit={false}
      primaryButtonText="Reset"
      secondaryButtonCallback={modalManager.close}
      submitting={loading}
      wrapperClassName="pr20 pl20 pb20"
    />
  );

  const warningText = () => {
    if (gameType === 'reading_game') {
      return (
        'Are you sure? This student\'s scores and work for the all the reading checks in the lesson will get cleared.'
      );
    }

    return `Are you sure? This student's score for the ${gameTypesHash[gameType]} Game will be permanently deleted.`;
  };

  const modal = () => (
    <Modal closeModal={modalManager.close} footer={footer()} headerText="Reset Game" isOpen={modalManager.isOpen}>
      {warningText()}
    </Modal>
  );

  return (
    <>
      <button className="btn btn--purple" type="button" onClick={modalManager.open}>
        Reset Total Score
      </button>
      {modal()}
    </>
  );
};

export default GameResetButton;
